import React, { useEffect, useState } from 'react';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import {
  getLeadsForEllipsesTooltip,
  getLeadsForEllipsesTooltipWidth,
} from '@/finsight/ui/components/deals/DealListTable/helpers';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const LeadForEllipses = ({
  structuringLeadsForEllipses,
  jointLeadsForEllipses,
  isLast,
}) => {
  const [maxWidth, setMaxWidth] = useState('300px');
  useEffect(() => {
    const mxWidth = getLeadsForEllipsesTooltipWidth(
      structuringLeadsForEllipses,
      jointLeadsForEllipses,
      isLast,
    );
    setMaxWidth(mxWidth);
  }, [
    structuringLeadsForEllipses,
    jointLeadsForEllipses,
    isLast,
  ]);

  const content = getLeadsForEllipsesTooltip(
    structuringLeadsForEllipses,
    jointLeadsForEllipses,
  );

  return (!!structuringLeadsForEllipses.length || !!jointLeadsForEllipses.length) && (
    <>
      <span>,</span>
      <span className={ spacesStyles.mlx }>
        <Tooltip maxWidth={ maxWidth } content={ content }>
          ...
        </Tooltip>
      </span>
    </>
  );
};

export default LeadForEllipses;
